import api from "./api";

export const GetEstabRegiao = async (regiao, tipo) => {
  try {
    const response = await api.get(
      `/v2/estabelecimentos/por-regiao/${regiao}?tipo=${tipo}`,
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const MudarStatusEstabelecimento = async (status, estabelecimento) => {
  try {
    const stab = await api.put(`/estabelecimentos/${estabelecimento._id}`, {
      status: status,
    });
    return stab.data.status;
  } catch (error) {
    throw error;
  }
};

export const MudarStatusEntrega = async (status_entrega, estabelecimento) => {
  try {
    const stab = await api.put(`/estabelecimentos/${estabelecimento._id}`, {
      entrega_propria: status_entrega,
    });
    return stab.data;
  } catch (error) {
    throw error;
  }
};

export const MudarStatusDestaque = async (status, estabelecimento) => {
  try {
    const stab = await api.put(`/estabelecimentos/${estabelecimento._id}`, {
      estabelecimento_destaque: status,
    });
    return stab.data;
  } catch (error) {
    throw error;
  }
};

export const MudarStatusEstabelecimentoModelo = async (status, estabelecimento) => {
  try {
    const stab = await api.put(`/estabelecimentos/${estabelecimento._id}`, {
      estabelecimento_modelo: status,
    });
    return stab.data;
  } catch (error) {
    throw error;
  }
};

export const ListarEstabelecimentos = async (page = 1) => {
  try {
    const estabelecimentos = await api.get(`/estabelecimentos?page=${page}`);
    return estabelecimentos.data;
  } catch (error) {
    throw error;
  }
};

export const ListarEstabelecimentosSemPaginacao = async (select = "") => {
  try {
    const { data } = await api.get(`/estabelecimentos/sem-paginacao?select=${select}`);
    return data;
  } catch (error) {
    throw error;
  }
};

export const ListarCorredoresEstabelecimento = async (idEstabelecimento) => {
  try {
    const corredores = await api.get(`/estabelecimentos/${idEstabelecimento}/corredores`);
    return corredores.data;
  } catch (error) {
    throw error;
  }
};

export const CadastrarEstabelecimento = async (dados, dadosEndereco, dadosUsuario) => {
  try {
    const endereco = await api.post(`/enderecos`, dadosEndereco);
    const usuario = await api.post(`/registrar`, dadosUsuario);

    if (endereco.data && usuario.data) {
      dados.append("endereco", endereco.data._id);
      dados.append("usuario", usuario.data.usuario._id);
      const estabelecimento = await api.post(`/estabelecimentos`, dados);
      return estabelecimento.data;
    }
  } catch (error) {
    throw error;
  }
};

export const EditarEstabelecimento = async (
  dados,
  dadosEndereco,
  dadosUsuario,
  estabelecimento,
) => {
  try {
    await api.put(`/enderecos/${estabelecimento.endereco._id}`, dadosEndereco);
    await api.put(`/usuarios/${estabelecimento.usuario._id}`, dadosUsuario);
    const res = await api.put(`/estabelecimentos/${estabelecimento._id}`, dados);
    return res.data;
  } catch (error) {
    throw error;
  }
};

export const DeletarEstabelecimento = async (dados) => {
  try {
    const estabelecimento = await api.delete(`/estabelecimentos/${dados._id}`);
    return estabelecimento.data;
  } catch (error) {
    throw error;
  }
};

export const CriarClonagemEstabelecimentos = async (data) => {
  try {
    const res = await api.post(`/estabelecimentos/clonagem`, data);
    return res.data;
  } catch (error) {
    throw error;
  }
};
